export default __webpack_public_path__ + "static/media/19.b0393828.jpg";